import { useMutation } from '@apollo/client/react';
import {
  Container,TextField,FormControlLabel
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ClassicButton from 'components/buttons/ClassicButton';
import FormController, { RenderCallback, ValidationRules, ValidationRuleType } from 'components/controllers/FormController';
import { useSessionState } from 'context/session/session';
import gql from 'graphql-tag';
import { withApollo } from 'hoc/withApollo';
import { useSnackbar } from 'notistack';
import {
  ChangeEvent, useEffect, useState,
} from 'react';
import withDndProvider from 'hoc/withDnDProvider';

const CONTACT_ACTORFORM = gql`
  mutation contactActor($formValues: ContactActorFormInfos!) {
    contactActor(contactActorInfos: $formValues)
  }
`;

const useStyles = makeStyles()((theme) => ({
  formContainer: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
  },
  field: {
    marginBottom: theme.spacing(3),
  },
  radioGroup: {
    marginBottom: theme.spacing(3),
    justifyContent: 'center',
  },
}));

type FormItemProps = {
  label: string;
  inputName: string;
  formChangeHandler: (event: ChangeEvent) => void;
  value: string;
  required: boolean;
  errorBool: boolean;
  errorText: string;
  helperText?: string;
  multiline?: boolean;
  fullWidth?: boolean;
  minRows?: number;
  maxRows?: number;
};

const FormItem = (props: FormItemProps) => {
  const { classes: styles } = useStyles();
  const {
    label,
    inputName,
    formChangeHandler,
    value,
    required,
    errorBool,
    errorText,
    helperText,
    multiline,
    fullWidth,
    minRows,
    maxRows,
  } = props;
  return (
    <TextField
      variant="outlined"
      value={value}
      label={label}
      name={inputName}
      onChange={formChangeHandler}
      fullWidth={fullWidth}
      required={required}
      error={errorBool}
      helperText={errorBool ? errorText : helperText}
      multiline={multiline}
      minRows={minRows}
      maxRows={maxRows}
      className={styles.field}
    />
  );
};

const ContactFormActor = (props) => {
  const {
    actorId,
  } = props;

  const { classes: styles } = useStyles();
  const user = useSessionState();
  const [messageSent, setMessageSent] = useState(false);
  const [lastActorNameSent, setLastActorNameSent] = useState('');
  const initFormValues = {
    firstName: user?.surname,
    lastName: user?.lastname,
    email: user?.email,
    actorId: actorId,
  };

  const Form: RenderCallback = (props) => {
    const { formChangeHandler, formValues, validationResult } = props;
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [
      contactActor,
      { data: contactActorData, error: contactActorError, loading: contactActorLoading },
    ] = useMutation(CONTACT_ACTORFORM);

    const inputs: Array<{
      label: string;
      name: string;
      required: boolean;
      errorText?: string;
      fullWidth?: boolean;
      multiline?: boolean;
      minRows?: number;
      maxRows?: number;
    }> = [

    ];
    if (!user) {
      inputs.push({
        label: 'Votre nom à vous',
        name: 'requesterName',
        required: true,
        errorText: 'Nom requis.',
        fullWidth: true,
      });
    
    }
    inputs.push({
      label: "Message pour l'AMAP",
      name: 'message',
      required: false,
      multiline: true,
      fullWidth: true,
    });
    const inputError = (name: string) => {
      return !validationResult?.global && !!validationResult?.result[name] && formValues[name] !== undefined;
    };

    const submitContactForm = () => {
      contactActor({
        variables: {
          formValues: {
            ...formValues,
          },
        },
      });
    };

    useEffect(() => {
      if (!contactActorLoading && contactActorData) {
        setMessageSent(true);
        inputs.map((input, i) => {
          if (input.name === 'actorName') {
            setLastActorNameSent(formValues[input.name]);
          }
          formValues[input.name] = '';
        });
      } else if (contactActorError) {
        enqueueSnackbar('Une erreur s\'est produite, merci de bien vouloir réessayer.', {
          preventDuplicate: true,
        });
      }
    }, [contactActorData, contactActorError, contactActorLoading]);

    const getFormInputs = (() => {
      return (
        <div>
          { inputs && inputs.map((input, i) => {
            return (
              <FormItem
                key={i}
                label={input.label}
                inputName={input.name}
                formChangeHandler={formChangeHandler}
                value={formValues[input.name]}
                required={input.required}
                errorBool={inputError(input.name)}
                errorText={input.errorText || ''}
                multiline={input.multiline}
                fullWidth={input.fullWidth}
                minRows={input.minRows}
                maxRows={input.maxRows}
              />
            );
          })}
        </div>
      );
    });

    return (
      <Container maxWidth="md" className={styles.formContainer}>
        { getFormInputs() }
        <ClassicButton
          fullWidth
          variant="contained"
          onClick={submitContactForm}
          disabled={!validationResult?.global}
        >
          { "Envoyer l'email"}
        </ClassicButton>
      </Container>
    );
  };
  let validationRules: ValidationRules;
  if (!user) {
    validationRules = {
      requesterName: {
        rule: ValidationRuleType.required,
      },
    };
  } else {
    validationRules = {
    };
  }

  if (messageSent) {
    return (
      <div>
        <div className={styles.formContainer}>
          <p>
            Votre email
            {' '}
            <b>{lastActorNameSent}</b>
            {' '}
            a bien été envoyé.
          </p>
        </div>
        <FormController
          render={Form}
          validationRules={validationRules}
          initValues={initFormValues}
        />
        ;
      </div>
    );
  }
  return (
    <FormController
      render={Form}
      validationRules={validationRules}
      initValues={initFormValues}
    />
  );
};

export default withDndProvider(withApollo()(ContactFormActor));
